import React from "react";

export const Page9English = () => {
  return (
    <div className="page-container">
      <p>
        He went straight to the astrologer. The astrologer was shocked to see
        him from a distance. He was surprised that his calculations had not been
        wrong so far and that he was the only one who had survived and asked him
        what happened at night. He also told in detail that he had stayed in the
        temple and that he had not slept since dawn and was planning to renovate
        the temple and that the temple collapsed as soon as he came out of the
        temple. Hearing him say that his survival was the work of God, the
        astrologer fell at his feet. He said, "If you plan to renovate the
        temple, you will get great benefits. If you help me do it, I will get
        great benefits. Therefore, I will hand over all my property to you. Do
        the renovation and I will get the benefits too." Hearing this news, the
        people of that village also helped in the renovation as much as they
        could. Uttaman also renovated the temple beautifully.
      </p>
      <p>
        He performed the Kumbabhishekam according to the Agama rules and made
        the benefits available to himself and the people of that village and
        received great blessings.
      </p>
      <p>
        We kindly request you to help us with such a highly beneficial temple
        renovation and Kumbabhishekam. Those who are wealthy should donate gold,
        those who are poor should help with at least a few coins, and that too,
        if not, give physical labor for the renovation.
      </p>
      <p>
        Every year, crores of new soil from grass, ten crores <br />
        Selluma Jnalam, one hundred crores from bricks
        <br />
        Alliyangothai Pagan Temple and monasteries
        <br />
        He built them with stone and left the temple that day.
      </p>
      <h1>Explanation of the Kumbabhishekam (consecration) lamp:</h1>
      <p>
        There are sixty-four activities performed as part of the Kumbabhishekam.
        Some Agamas say fifty-five. Among them, Anugnai, Ganapati Puja, Vastu
        Shanti, Mrut Sankiranam, Angurarpanam, Rakshabandhanam, Kumbhasthapanam,
        Kalakarshanam, Yagashalai Bimbasuddhi, Sparsakhuthi, etc. are essential.
        Anugnai is the process of selecting a priest and appointing him to
        perform the Kumbabhishekam after obtaining the permission of the Lord.
        Ganapati Puja is a form of worship that is performed without any
        hindrance. Vastu Shanti - cleaning the earth, Mrut Sankiranam - taking
        soil, Angurarpanam and sprouting, Rakshabandhanam and securing it,
        adding the yagash benefits obtained from Bimbasuddhi to the idols. In
        this way, every activity is performed in the Yagashalai.
      </p>
    </div>
  );
};
